<template>
    <Snowf
        :amount="random(20, 40)"
        :size="random(3, 7)"
        :speed="random(1, 2.5)"
        :wind="[-1, 0, 1][Math.round(random(0, 2))]"
        :opacity="0.8"
        :swing="1"
        :image="require('@/images/snow.svg?url')"
        :zIndex="2147483647"
        :resize="false"
        color="#fff"
        v-if="isWinter && isSnowEnabled"
    />
</template>
<script>
import Vue from 'vue';
import Snowf from 'vue-snowf';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { isWinterSeason } from '@/js/season';

@Component({
    components: {
        Snowf,
    },
})
class VSnowfall extends Vue {
    @Prop({ type: Boolean })
    isSnowEnabled;

    random(min, max) {
        return Math.random() * (max - min) + min;
    }

    get isWinter() {
        return isWinterSeason();
    }

    mounted() {
        if (!this.isWinter) {
            return;
        }

        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        link.href = link.href.replace(/favicon\.(ico|png)/, 'favicon-winter.ico');
    }
}

export default VSnowfall;
</script>
<style lang="scss">
.snowf-canvas {
    pointer-events: none;
}
</style>
